// Google Business Profile — static trust data.
// Source of truth: Andrea's official Google Business Profile, registered as
// "The Nurtured Parent Collective" (identity confirmed via the listing's own
// website thenurturedparentco.com and phone (720) 926-3037).
//
// GOOGLE_RATING and GOOGLE_REVIEW_COUNT are a MANUAL SNAPSHOT of the profile
// (owner-confirmed 2026-10-05) — they are NOT live data and the site never
// claims they are. To update: check the profile and change the two values below. Nothing else
// in the codebase hardcodes them.
export const GOOGLE_PROFILE_URL = "https://share.google/9ajwkzmtTmZJFthtf";
export const GOOGLE_RATING = "5.0";
export const GOOGLE_REVIEW_COUNT = 17;
